import { cn } from "src/common/utils";

const SentryIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-1")}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="100%"
      height="100%"
      viewBox="0 0 64 64"
    >
      <path d="M38.064 7.214C36.618 4.7 34.4 3.258 32.007 3.258S27.395 4.7 25.95 7.214l-7.632 13.26c1.9 1.066 3.7 2.277 5.417 3.613 9.114 7.135 15.256 17.914 16.234 30.136h-4.793c-.944-10.455-6.148-19.7-13.854-25.944-1.685-1.368-3.487-2.59-5.392-3.656L7 40.163a19.95 19.95 0 0 1 5.179 4.014c2.543 2.748 4.314 6.212 4.986 10.05l-8.01-.004c-.88 0-1.594-.716-1.594-1.598a1.62 1.62 0 0 1 .192-.763l2.022-3.44c-1.49-1.608-3.235-2.97-5.18-4.014l-3.39 5.808C-.25 52.728-.392 55.367.8 57.455s3.55 3.286 6.443 3.286h16.51c.117-1 .184-2.036.184-3.075a26.48 26.48 0 0 0-.23-3.438C22.904 48 19.91 42.432 15.526 38.35l2.5-4.343c5.804 5.033 9.745 12.17 10.626 20.22a31.4 31.4 0 0 1 .194 3.438 31.87 31.87 0 0 1-.153 3.075h17.8c.063-1.018.105-2.04.105-3.075 0-1.157-.054-2.3-.132-3.438C45.46 39.6 38.044 26.714 27 18.396l3.632-6.31c.28-.463.788-.773 1.365-.773a1.59 1.59 0 0 1 1.386.81l22.863 39.74a1.6 1.6 0 0 1 .193.763c0 .884-.714 1.598-1.594 1.598l-3.588.004a49.83 49.83 0 0 1 .133 3.437c0 1.035-.043 2.06-.107 3.075h5.452c2.895 0 5.243-1.196 6.443-3.286s1.06-4.727-.385-7.24z" fill="#465264"/>
    </svg>
  </div>
);

export default SentryIcon;
